import React from "react";

import styled from "styled-components/macro";

import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { motion } from "framer-motion";

import FnrUserPhoto from "UI/FnrUserPhoto";

export default function NoteInfo() {
  const { state } = usePaymentPage();
  const { author, title, noteUrl } = state.noteInfo;

  const getDisplayTitle = () => {
    if (!title) return "";
    else if (title.length < 160) return title;
    else {
      // truncates at the end of a word. stolen from https://stackoverflow.com/questions/5454235
      return title.replace(/^(.{160}[^\s]*).*/, "$1") + "...";
    }
  };

  const goToNote = () => window.open(noteUrl, "_blank");

  if (!state.noteInfo || !state.noteInfo?.noteID) return null;

  return (
    <Wrapper>
      <InnerWrapper>
        <Icon
          initial={{ opacity: 0, scale: 0.2, y: 60, rotate: "-12deg" }}
          animate={{
            opacity: 1,
            scale: [0.2, 1.8, 1],
            y: 0,
            rotate: ["-18deg", "12deg", "0deg"],
          }}
        >
          <FnrUserPhoto url={author?.photoURL} size={52} />
        </Icon>
        <MessageHolder
          initial={{ opacity: 0, y: 12, scale: 0.5, rotate: "12deg" }}
          animate={{
            opacity: 1,
            y: 0,
            scale: 1,
            rotate: ["10deg", "-3deg", "0deg"],
            transition: { delay: 0.45 },
          }}
        >
          <Text
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            onClick={goToNote}
          >
            <TextInside>
              <From>From {author?.name}</From>
              <Title>{getDisplayTitle()}</Title>
            </TextInside>
          </Text>
        </MessageHolder>
      </InnerWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  padding-left: min(12px, 4%);
  padding-right: min(12px, 4%);
  margin-top: -22px;
`;

const InnerWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`;

const Icon = styled(motion.div)`
  flex-grow: 0;
  flex-shrink: 0;
  position: relative;
  z-index: 100;
  margin-right: 8px;
  margin-bottom: -4px;
  position: absolute;
`;

const MessageHolder = styled(motion.div)`
  transform-origin: 0% 100%;
  padding-left: 60px;
`;

const Text = styled(motion.div)`
  border-radius: 1.15rem;
  line-height: 1.25;
  padding: 0.5rem 0.875rem;
  position: relative;
  word-wrap: break-word;
  cursor: pointer;
  background-color: #248bf5;
  box-shadow: rgba(0, 0, 0, 0.3) 1px 1px 4px;
  color: #fff;
  flex-grow: 1;
  &:before {
    bottom: -0.2rem;
    content: "";
    height: 2rem;
    position: absolute;
    border-bottom-right-radius: 1.6rem 1.4rem;
    border-left: 2rem solid #248bf5;
    left: -0.7rem;
    transform: translate(0, -0.2rem);
    z-index: 1;
  }
  &:after {
    bottom: -0.2rem;
    content: "";
    height: 2rem;
    position: absolute;
    background-color: #f7f7f7;
    border-bottom-right-radius: 1rem;
    left: 20px;
    transform: translate(-32px, -4px);
    width: 12px;
    z-index: 2;
  }
`;
const TextInside = styled.div`
  position: relative;
  z-index: 40;
`;
const From = styled.div`
  font-size: 14px;
`;

const Title = styled.div`
  font-weight: 400;
  font-size: 18px;
`;
